export function SectionTitle({ label }) {
  return (
    <div className="">
      <h3 className="text-lg font-medium leading-6 text-gray-900">{label}</h3>
    </div>
  );
}
